
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/adobe-experience-platform",
      function () {
        return require("private-next-pages/destinations/adobe-experience-platform.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/adobe-experience-platform"])
      });
    }
  